import { CallbackSaga, createGeneralCall } from '@altermaind/core/requests-status-management';
import { IS_MOCK_ENABLED } from '@/_shared/constants/mock';
import { GenericGet } from '@/_shared/types';
import { getCurrentOrganization } from '@/core/state/selectors';
import { API_ORGANIZATIONS_ORGANIZATIONID_CONTENTS_LIKES_PATH_KEY } from '@/swagger/constants/contents-likes-keys';
import {
  API_GET_ADMIN_CONTENTS_LIKES_BY_CONTENT_TYPE,
  KEY_GET_ADMIN_CONTENTS_LIKES_BY_CONTENT_TYPE,
} from '../constants';
import { MOCK_RESPONSE_GET_ADMIN_CONTENTS_LIKES_BY_CONTENT_TYPE } from '../mocks';
import { ContentLike } from '../types';

type ResponseGetContentsLikes = GenericGet<
  typeof API_ORGANIZATIONS_ORGANIZATIONID_CONTENTS_LIKES_PATH_KEY
>['response']['body'];

export type CallParamsGetAdminContentsLikesByContentType = {
  contentType: ContentLike;
  successSaga?: CallbackSaga;
  errorSaga?: CallbackSaga;
};

type CallResponseGetAdminContentsLikes = ResponseGetContentsLikes;

type CallErrorGetAdminContentsLikes = {
  message: string;
  code: number;
};

type CallSelectorsGetAdminContentsLikes = unknown;

export const getAdminContentsLikesByContentTypeCall = createGeneralCall<
  CallParamsGetAdminContentsLikesByContentType,
  CallResponseGetAdminContentsLikes,
  CallErrorGetAdminContentsLikes,
  CallSelectorsGetAdminContentsLikes
>({
  id: KEY_GET_ADMIN_CONTENTS_LIKES_BY_CONTENT_TYPE,
  url:
    ({ payload }) =>
    state => {
      const org = getCurrentOrganization(state);
      return API_GET_ADMIN_CONTENTS_LIKES_BY_CONTENT_TYPE(
        org as unknown as string,
        payload.contentType,
      );
    },
  paramsSelector:
    ({ payload }) =>
    () => {
      return payload;
    },
  method: 'get',
  successMock: IS_MOCK_ENABLED()
    ? MOCK_RESPONSE_GET_ADMIN_CONTENTS_LIKES_BY_CONTENT_TYPE
    : undefined,
});
